export default {"src":"/_next/static/media/susd.3aa0b6c4.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};